import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=07aafcfe&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aafcfe')) {
      api.createRecord('07aafcfe', component.options)
    } else {
      api.reload('07aafcfe', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=07aafcfe&", function () {
      api.rerender('07aafcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9vtGYn280ac/JS/comp/ImgFallback.vue"
export default component.exports